import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

function Counters() {
  return (
    <MKBox component="section"  bgcolor="#f8f9fa">
      <Container>
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <DefaultCounterCard
              count={100}
              suffix="%"
              title="Confiabilidade"
              description="Processos controlados para garantir precisão e qualidade em cada peça."
              sx={{ textAlign: "center" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DefaultCounterCard
              count={10}
              suffix="+"
              title="Máquinas e Equipamentos"
              description="Parque industrial completo com tornos, fresas e centros CNC para qualquer desafio."
              sx={{ textAlign: "center" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DefaultCounterCard
              count={500}
              suffix="m²"
              title="Área construída"
               description="Estrutura planejada para fluxo produtivo eficiente, metrologia e expedição."
              sx={{ textAlign: "center" }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
